import { render, staticRenderFns } from "./ModalAbout.vue?vue&type=template&id=4cdfff52&scoped=true"
import script from "./ModalAbout.vue?vue&type=script&lang=js"
export * from "./ModalAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdfff52",
  null
  
)

export default component.exports